/* 🤖 this file was generated by svg-to-ts */
export const matIconSwapVert: {
  name: 'swap-vert';
  data: string;
} = {
  name: 'swap-vert',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3 5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3 5 6.99h3V14h2V6.99h3L9 3z"/></svg>`
};
